import { IExecutionOptions, IQueryOptions } from '../../models/query';
import { BaseTransform } from './BaseTransform';
import formatter from '../../utils/formatter';
import { Query } from '../Query';
import { deepMergeObjects } from '../../utils/object';

export class FormatTransform extends BaseTransform {
	execute(queryResponse: any, queryOptions: IQueryOptions, executionOptions: IExecutionOptions) {
		let response: any = queryResponse;
		const { formatTransformOptions } = this.options;
		if (formatTransformOptions) {
			const { format: originalFormat, currencyQuery: currencyQueryOptions } = formatTransformOptions;
			let format = originalFormat;
			if (format) {
				const { currency, culture, translate } = executionOptions;
				if (format.globalFormatKey) {
					const globalFormat = executionOptions && executionOptions.globalFormatsByKey && executionOptions.globalFormatsByKey[format.globalFormatKey];
					if (globalFormat && globalFormat.format) {
						format = deepMergeObjects(globalFormat.format, format);
					}
				}
				const { type, transforms } = format;
				let workingCurrency = currency;
				if (currencyQueryOptions) {
					const currencyQuery = new Query(currencyQueryOptions);
					workingCurrency = currencyQuery.execute(executionOptions);
				}
				response = formatter(type, culture, workingCurrency, format.options, queryResponse, transforms, translate);
			}
		}
		return response;
	}
}